var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { validateEmail } from '../../common';
import { isNotIncludedEmailDomain } from '../../utils';
import { validateAdminAccountStatus } from './proffit_search_common_validate';
export const proffitSearchAccountAdminValidate = {
    admin: [
        ...validateEmail,
        (value, record, props) => {
            const { enableDomains } = props;
            return isNotIncludedEmailDomain(enableDomains, 'ドメインが異なるメールアドレスは登録できません')(value);
        },
        (value, record, props) => {
            const { billingInformation } = props;
            return billingInformation &&
                billingInformation.filter((v) => v.email === value).length > 0
                ? '既に請求書送付先（Cc）に登録済みです'
                : '';
        },
    ],
    form: (values, dispatch, formProp, fieldName) => __awaiter(void 0, void 0, void 0, function* () {
        const { unMountRef } = formProp;
        if (fieldName) {
            const result = yield validateAdminAccountStatus(dispatch, values[fieldName], fieldName);
            if (unMountRef.current) {
                return;
            }
            const errorObject = { admin: result.error };
            if (result.error) {
                throw errorObject;
            }
        }
    }),
};
export default proffitSearchAccountAdminValidate;
